import { constantRoutes } from '@/router'
import { normalizeOaMenus } from '@/utils/oa'
import { getRouters } from '@/api/menu'
import Layout from '@/layout/index'
import { filterPurchasePriceMenus } from '@/utils/purchase-price-access'

const permission = {
  state: {
    routes: [],
    addRoutes: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit, rootGetters }) {
      return new Promise(resolve => {
        // 向后端请求路由数据
        getRouters().then(res => {
          const accessedRoutes = filterAsyncRouter(filterPurchasePriceMenus(normalizeOaMenus(res.data), rootGetters.roles))
          accessedRoutes.push({ path: '*', redirect: '/workbench', hidden: true })
          commit('SET_ROUTES', accessedRoutes)
          resolve(accessedRoutes)
        })
      })
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    // The common workbench is a constant route available to every signed-in user.
    if (route.component === 'index' || route.path === '/crm/index' || route.path === '/workbench') return false
    // One role-scoped expense list replaces separate daily-use expense menus.
    if (route.component === 'crm/expense/payments') return false
    if (['crm/expense/settings', 'crm/expense/ledger'].includes(route.component)) route.hidden = true
    if (route.component === 'crm/expense/index') route.meta = { ...route.meta, title: '报销申请', noCache: true }
    if (route.component === 'oa/index') route.meta = { ...route.meta, noCache: true }
    route.businessNum = null
    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
      if (!route.children.length) return false
      if (['finance', '/finance'].includes(route.path) && route.children.every(child => child.hidden)) route.hidden = true
    }
    return true
  })
}

export const loadView = (view) => { // 路由懒加载
  return (resolve) =>  require([`@/views/${view}`], resolve)
}

export default permission
